import React, { useMemo, useState, useEffect } from "react";
import { Badge, Button, Col, Form, Image, InputGroup, Modal, Row, Table, Nav } from "react-bootstrap";
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';
import '../../assets/styles/Freames.css';
import { oneKlicks } from '../../SDK/oneclick';
import ImageShow from '../../Uitiles/ImageShow';
import { useNavigate } from 'react-router-dom';
import Paginationnew from "../../Uitiles/Paginationnew";

const ProfessionalWebsite = () => {
  const navigate = useNavigate();
  const [frames, setFrames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [selectedFrame, setSelectedFrame] = useState(null);
  const [type, setType] = useState([
    {
      id: 1,
      label: "Doctor",
      value: "doctor"
    },
    {
      id: 2,
      label: "Hospital",
      value: "hospital"
    },
    {
      id: 3,
      label: "Clinic",
      value: "clinic"
    },

    {
      id: 4,
      label: "Pharmacy",
      value: "pharmacy"
    },
    {
      id: 5,
      label: "Laboratory",
      value: "laboratory"
    },
    {
      id: 6,
      label: "Other",
      value: "other"
    }
  ]);
  const [selectedType, setSelectedType] = useState("");
  const [uploadForm, setUploadForm] = useState({
    title: '',
    description: '',
    category: '',
    status: 'publish'
  });
  const [editForm, setEditForm] = useState({
    title: '',
    description: '',
    category: '',
    status: 'publish'
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedwebsitezipfile, setSelectedwebsitezipfile] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCategory, setFilterCategory] = useState('all');

  // Mock data for demonstration - replace with actual API calls
  const mockFrames = [
    {
      id: 1,
      title: 'Modern Frame Design',
      description: 'Contemporary frame with clean lines',
      category: 'Modern',
      status: 'publish',
      imageUrl: 'https://via.placeholder.com/300x200',
      created_at: '2024-01-15',
      fileId: 'frame_001'
    },
    {
      id: 2,
      title: 'Classic Wooden Frame',
      description: 'Traditional wooden frame design',
      category: 'Classic',
      status: 'publish',
      imageUrl: 'https://via.placeholder.com/300x200',
      created_at: '2024-01-10',
      fileId: 'frame_002'
    }
  ];

  useEffect(() => {
    loadFrames({ category: filterCategory });
  }, [filterCategory]);

  // Lock body scroll when any modal is open
  useEffect(() => {
    const isAnyModalOpen = showUploadModal || showEditModal;
    const body = document.body;
    

    const handleEsc = (e) => {
      if (e.key === 'Escape' && isAnyModalOpen) {
        setShowUploadModal(false);
        setShowEditModal(false);
        setSelectedFrame(null);
      }
    };
    window.addEventListener('keydown', handleEsc);
    
  }, [showUploadModal, showEditModal]);

  const loadFrames = async ({ category } = {}) => {
    setLoading(true);
    try {

      const tableSchema = "";
      const tableName = "professionalwebsite";
      const conditions = {};
      if (category && category !== 'all') {
        conditions.category = category;
      }
      const orderBy = "id DESC";
      const search = "";
      const pagination = { page: page, limit: limit }
      const margedata = "";
      const frames = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
      console.log("frames", frames);
      if (frames.status == 500) {
        setFrames(mockFrames);
        setLoading(false);
        return;
      }
      console.log("frames", frames.data);
      // Replace with actual API call to get frames
      // const response = await apiService.getFrames();
      // setFrames(response.data);

      // Using mock data for now
      setTotal(frames.totalPages);
      setTimeout(() => {
        if (frames.data.length > 0) {
          setFrames(frames.data);
        } else {
          setFrames(mockFrames);
        }
        setLoading(false);
      }, 1000);
    } catch (error) {
      console.error('Error loading frames:', error);
      setLoading(false);
    }
  };

  const handleFileSelect = async (event) => {
    console.log("handleFileSelect", event);
    const file = event.target.files[0];
    if (file) {
      const upload = await OneKlicksFileSDK.uploadFile(
        'professionalwebsite', // root folder
        "public",
        file
      );

      if (upload.success === true) {
        console.log("upload file url", `${upload.file.root}/${upload.file.fileName}`);
        setSelectedFile(file);
        setUploadForm(prev => ({ ...prev, imageUrl: `${upload.file.root}/${upload.file.fileName}` }));
        setUploadForm(prev => ({ ...prev, imageid: `${upload.fileId}` }));

      }
    }
  };

  const handleUpload = async () => {
    if (!selectedFile || !uploadForm.title.trim()) {
      alert('Please select a file and enter a title');
      return;
    }

    setUploading(true);
    try {
      // Upload file using OneKlicks SDK
      const tableSchema = "";
      const tableName = "professionalwebsite";
      const data = {
        title: uploadForm.title,
        description: uploadForm.description,
        category: uploadForm.category,
        status: uploadForm.status,
        imageUrl: uploadForm.imageUrl,
        imageid: uploadForm.imageid,
        blowPrintUrl: uploadForm.blowPrintUrl,
        blowPrintid: uploadForm.blowPrintid,
      }
      const conditions = {

      }
      const uploadResult = await oneKlicks.create(tableSchema, tableName, data, conditions)

      if (uploadResult.error) {
        throw new Error(uploadResult.error);
      }

      // Create frame record (replace with actual API call)
      const newFrame = {
        id: Date.now(),
        title: uploadForm.title,
        description: uploadForm.description,
        category: uploadForm.category,
        status: uploadForm.status,
        imageUrl: uploadForm.imageUrl || uploadResult.fileUrl || 'https://via.placeholder.com/300x200',
        blowPrintUrl: uploadForm.blowPrintUrl,
        blowPrintid: uploadForm.blowPrintid,
        created_at: new Date().toISOString().split('T')[0],
        fileId: uploadResult.id || `frame_${Date.now()}`
      };

      setFrames(prev => [newFrame, ...prev]);
      setShowUploadModal(false);
      setUploadForm({ title: '', description: '', category: '', status: 'publish', created_at: new Date().toISOString().split('T')[0] });
      setSelectedFile(null);

      alert('Frame uploaded successfully!');
    } catch (error) {
      console.error('Upload error:', error);
      alert(`Upload failed: ${error.message}`);
    } finally {
      setUploading(false);
    }
  };

  const handleEditFileSelect = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const upload = await OneKlicksFileSDK.uploadFile(
        'professionalwebsite', // root folder
        "public",
        file
      );

      if (upload.success === true) {
        console.log("upload file url", `${upload.file.root}/${upload.file.fileName}`);
        setSelectedFile(file);
        setEditForm(prev => ({ ...prev, imageUrl: `${upload.file.root}/${upload.file.fileName}` }));
        setEditForm(prev => ({ ...prev, imageid: `${upload.fileId}` }));

      }
    }
  };

  const handleBlowPrintFileSelect = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const upload = await OneKlicksFileSDK.uploadFile(
        'professionalwebsite', // root folder
        "public",
        file
      );
      if (upload.success === true) {
        console.log("upload file url", `${upload.file.root}/${upload.file.fileName}`);
        setSelectedFile(file);
        setUploadForm(prev => ({ ...prev, blowPrintUrl: `${upload.file.root}/${upload.file.fileName}` }));
        setUploadForm(prev => ({ ...prev, blowPrintid: `${upload.fileId}` }));
      }
    }
  };

  const handlewebsitezipfile = async (event) => {
    console.log("handlewebsitezipfile", event);
    const file = event.target.files[0];
    if (file) {
      const upload = await OneKlicksFileSDK.uploadFile(
        'professionalwebsite', // root folder
        "public",
        file
      );
      if (upload.success === true) {
        console.log("upload file url", `${upload.file.root}/${upload.file.fileName}`);
        setSelectedwebsitezipfile(file);
        setEditForm(prev => ({ ...prev, websitezipfile: `${upload.file.root}/${upload.file.fileName}` }));
        setEditForm(prev => ({ ...prev, websitezipid: `${upload.fileId}` }));
      }
    }
  };

  const handleupdate = async () => {
    console.log("editForm", editForm);
    const tableSchema = "";
    const tableName = "professionalwebsite";
    const data = {
      title: editForm.title,
      description: editForm.description,
      category: editForm.category,
      status: editForm.status,
      imageUrl: editForm.imageUrl,
      imageid: editForm.imageid,
      websitezipfile: editForm.websitezipfile,
      websitezipid: editForm.websitezipid,
    }
    const conditions = {
      id: selectedFrame.id,
    }
    const updateResult = await oneKlicks.update(tableSchema, tableName, data, conditions);
    if (updateResult.error) {
      throw new Error(updateResult.error);
    }
    setShowEditModal(false);
    setSelectedFrame(null);
    alert('Frame updated successfully!');

    setFrames(prev => prev.map(frame =>
      frame.id === selectedFrame.id
        ? { ...frame, ...editForm }
        : frame
    ));

    loadFrames();
  }

  const handleDelete = async (frameId, fileId) => {
    if (!window.confirm('Are you sure you want to delete this frame?')) {
      return;
    }

    try {
      // Delete file from OneKlicks if fileId exists
      if (fileId) {
        await OneKlicksFileSDK.deleteFile(fileId);
      }

      // Remove frame from list (replace with actual API call)
      setFrames(prev => prev.filter(frame => frame.id !== frameId));
      alert('Frame deleted successfully!');
    } catch (error) {
      console.error('Delete error:', error);
      alert(`Delete failed: ${error.message}`);
    }
  };

  const openEditModal = (frame) => {
    setSelectedFrame(frame);
    setEditForm({
      title: frame.title,
      description: frame.description,
      category: frame.category,
      status: frame.status,
      imageUrl: frame.imageUrl,
      imageid: frame.imageid,
      blowPrintUrl: frame.blowPrintUrl,
      blowPrintid: frame.blowPrintid,
    });
    setShowEditModal(true);
  };

  const normalizeCategory = (value) => {
    if (!value) return '';
    let s = String(value).toLowerCase().trim();
    s = s.replace(/[\-_]+/g, ' ').replace(/\s+/g, ' ');
    // strip simple plural
    if (s.endsWith('s')) s = s.slice(0, -1);
    if (s.startsWith('doc')) return 'doctor';
    if (s.startsWith('hosp')) return 'hospital';
    if (s.startsWith('lab')) return 'laboratory';
    if (s.startsWith('pharm')) return 'pharmacy';
    if (s.startsWith('clin')) return 'clinic';
    return s;
  };

  const filteredFrames = frames.filter(frame => {
    const title = (frame.title || '').toLowerCase();
    const desc = (frame.description || '').toLowerCase();
    const matchesSearch = title.includes(searchTerm.toLowerCase()) || desc.includes(searchTerm.toLowerCase());
    const selectedCat = normalizeCategory(filterCategory);
    const itemCat = normalizeCategory(frame.category);
    const matchesCategory = selectedCat === 'all' || itemCat === selectedCat || itemCat.includes(selectedCat);
    return matchesSearch && matchesCategory;
  });


  

  return (
    <>
      <div className="dc-haslayout dc-dbsectionspace">
        <div className="container-fluid py-3">
          <div className="card mb-5">
            <div className="card-body">
              <div className="align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center gap-2  mb-2">
                  <h5 className="mb-0 font-weight-bold mr-3">Website Templates</h5>
                  <Badge bg="info">Management</Badge>
                </div>
                <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                  <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                    <InputGroup className="p-0" style={{ maxWidth: 400, flex: "1 1 auto" }}>
                      <Form.Control
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </InputGroup>
                    <Form.Select
                      className='form-control'
                      value={selectedType}
                      onChange={(e) => setSelectedType(e.target.value)}
                    >
                      <option value="" defaultValue>Select Type</option>
                      {type.map((type) => (
                        <option key={type.id} value={type.value}>{type.label}</option>
                      ))}
                    </Form.Select>
                  </div>

                  <Button variant="primary" style={{ height: 40, width: 150 }} onClick={() => setShowUploadModal(true)}>+ Add Template</Button>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
                <div className="row g-3">
                  {filteredFrames.length === 0 ? (
                    <div className="col-12 text-center text-muted py-5">
                      <p className="mb-0">No templates found. Click "Add Template" to upload.</p>
                    </div>
                  ) : (
                    filteredFrames.map(frame => (
                      <div key={frame.id} className="col-lg-3 col-md-6 col-sm-12 mb-3">
                        <div className="card h-100 shadow-sm">
                          <div className="bg-light" style={{ width: '100%', height: 200 }}>
                            <ImageShow url={frame.imageUrl} height={200} width={0} style={{ width: '100%', objectFit: 'cover' }}/>
                          </div>
                          <div className="card-body">
                            <h6 className="card-title mb-1 text-truncate" title={frame.title}>{frame.title}</h6>
                            <p className="card-text text-muted mb-2" title={frame.description}>
                              {(frame.description || '').length > 100 ? `${(frame.description || '').slice(0, 100)}...` : (frame.description || '')}
                            </p>
                            <div className="d-flex justify-content-between flex-wrap align-items-center gap-2 small ">
                              <div className="d-flex flex-wrap align-items-center gap-2">
                                <span className="badge bg-light text-dark">{frame.category}</span>
                                <span className={`badge ${(String(frame.status).toLowerCase() === 'publish') ? 'btn-primary' : 'btn-secondary'}`}>
                                  {frame.status ? frame.status.charAt(0).toUpperCase() + frame.status.slice(1).toLowerCase() : ''}
                                </span>
                              </div>
                              
                              <span className="text-muted ms-auto">{(frame.created_at || '').split('T')[0]}</span>
                            </div>
                          </div>
                          <div className="card-footer bg-transparent border-0 pt-0 pb-3 px-3 d-flex justify-content-between">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() => openEditModal(frame)}
                            >
                              Edit
                            </button>
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleDelete(frame.id, frame.fileId)}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
            <Paginationnew currentPage={page} totalPages={total} handlePageChange={setPage} />
          </div>
      </div>
      

        {/* Upload Modal */}
        <Modal show={showUploadModal} onHide={() => setShowUploadModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Upload New Template</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <label>Title *</label>
              <input
                type="text"
                value={uploadForm.title}
                onChange={(e) => setUploadForm(prev => ({ ...prev, title: e.target.value }))}
                placeholder="Enter template title"
              />
            </div>
            <div className="form-group">
              <label>Description</label>
              <textarea
                value={uploadForm.description}
                onChange={(e) => setUploadForm(prev => ({ ...prev, description: e.target.value }))}
                placeholder="Enter template description"
                rows="3"
              />
            </div>
            <div className="form-group">
              <label>Category</label>
              <select
                value={uploadForm.category}
                onChange={(e) => setUploadForm(prev => ({ ...prev, category: e.target.value }))}
              >
                <option value="">Select category</option>
                {type.filter(cat => cat !== 'all').map(cat => (
                  <option key={cat.id} value={cat.value}>{cat.label}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Status</label>
              <select
                value={uploadForm.status}
                onChange={(e) => setUploadForm(prev => ({ ...prev, status: e.target.value }))}
              >
                <option value="publish">Publish</option>
                <option value="draft">Draft</option>
              </select>
            </div>
            <div className="form-group">
              <label>Template zip file *</label>
              <input
                type="file"
                accept=".zip"
                onChange={handleBlowPrintFileSelect}
              />
              {selectedwebsitezipfile && (
                <p className="file-info">Selected: {selectedwebsitezipfile.name}</p>
              )}
            </div>
            <div className="form-group">
              <label>Template Image *</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleFileSelect}
              />
              {selectedFile && (
                <p className="file-info">Selected: {selectedFile.name}</p>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn btn-secondary" onClick={() => setShowUploadModal(false)}>
              Cancel
            </Button>
            <Button className="btn btn-primary" onClick={handleUpload} disabled={uploading}>
              {uploading ? 'Uploading...' : 'Upload Template'}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal show={showEditModal && !!selectedFrame} onHide={() => { setShowEditModal(false); setSelectedFrame(null); }} centered>
          <Modal.Header closeButton>
            <Modal.Title>Edit Template</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <label>Title *</label>
              <input
                type="text"
                value={editForm.title}
                onChange={(e) => setEditForm(prev => ({ ...prev, title: e.target.value }))}
                placeholder="Enter template title"
              />
            </div>
            <div className="form-group">
              <label>Description</label>
              <textarea
                value={editForm.description}
                onChange={(e) => setEditForm(prev => ({ ...prev, description: e.target.value }))}
                placeholder="Enter template description"
                rows="3"
              />
            </div>
            <div className="form-group">
              <label>Category</label>
              <select
                value={editForm.category}
                onChange={(e) => setEditForm(prev => ({ ...prev, category: e.target.value }))}
              >
                <option value="">Select category</option>
                {type.filter(cat => cat !== 'all').map(cat => (
                  <option key={cat.id} value={cat.value}>{cat.label}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Status</label>
              <select
                value={editForm.status}
                onChange={(e) => setEditForm(prev => ({ ...prev, status: e.target.value }))}
              >
                <option value="publish">Publish</option>
                <option value="draft">Draft</option>
              </select>
            </div>
          </Modal.Body>
          <Modal.Body>
            <div className="form-group">
              <label>Template zip file *</label>
              <input
                type="file"
                accept=".zip"
                onChange={handlewebsitezipfile}
              />
            </div>
          </Modal.Body>
          <Modal.Body>
            <ImageShow url={editForm.imageUrl} />
            <div className="form-group">
              <label>Template Image *</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleEditFileSelect}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn btn-secondary" onClick={() => setShowEditModal(false)}>
              Cancel
            </Button>
            <Button className="btn btn-primary" onClick={handleupdate}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
    </>
  );
};

export default ProfessionalWebsite;
